export const BlueskyIcon = ({ size = '16', className = '' }) => {
  return (
    <img
      src="/static/img/icons/bluesky-logo.svg"
      style={{ width: `${size}px`, height: `${size}px` }}
      className={className}
      alt="Bluesky Logo"
    />
  )
}

export default BlueskyIcon
